const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '/',
  PUSHER_EVENT_NAME: 'App\\Events\\NewLiveEvent',
  PUSHER_CLIENT_EVENT_NAME: 'client-App\\Events\\NewLiveEvent',
  PUSHER_REACTION_EVENT_NAME: 'client-App\\Events\\LiveReaction',
  PUSHER_LIVE_SALE_ENDED_EVENT_NAME: 'App\\Events\\LiveSaleEnded',
};

export default config;
